"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHiddenInput = exports.isClickOutside = void 0;
const isClickOutside = (windowClickEvent, element) => {
    if (!windowClickEvent || !element)
        return;
    const cursorX = windowClickEvent.clientX;
    const cursorY = windowClickEvent.clientY;
    if (cursorX === 0 && cursorY === 0)
        return false;
    const rect = element.getBoundingClientRect();
    const clickedOutsideX = cursorX < rect.left || cursorX > rect.right;
    const clickedOutsideY = cursorY < rect.top || cursorY > rect.bottom;
    return clickedOutsideX || clickedOutsideY;
};
exports.isClickOutside = isClickOutside;
function createHiddenInput(name, value) {
    const hiddenInput = document.createElement("input");
    hiddenInput.type = "hidden";
    hiddenInput.name = name;
    hiddenInput.value = value;
    return hiddenInput;
}
exports.createHiddenInput = createHiddenInput;
